import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { STATUS } from "@constants/status.hrm";
import { PaginationRequestType } from "@type/HRM/pagination";

const { EMPLOYEES } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${EMPLOYEES}`;

export const getDossier = (() => {
  return async (employeeID: number, query: PaginationRequestType) => {
    return api
      .get(`${apiEndPoint}/${employeeID}/dossier-info`, { params: query })
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();

export const createDossier = (() => {
  return async (
    employeeID: number,
    formData: any,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .post(`${apiEndPoint}/${employeeID}/dossier-info`, formData)
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const deleteDossier = (() => {
  return async (dossierID: number, afterEffect: (param: any) => void) => {
    return api
      .delete(`${apiEndPoint}/dossier-info/${dossierID}`)
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
